import {useMemo} from 'react';
import {APP_ROUTES, APP_ROUTES_KEYS, APP_ROUTES_TO_URL, PAGE} from '../../constants';
import {IQuery, IRouteFn, TAdressesPage, TRouteData} from '../../types';
import useRouteRedirect from 'core/hooks/useRoutesRedirect';
import {urlToRouteConverter} from '../../helpers';

export const useAddressesRoutes = (): TRouteData<TAdressesPage> => {
    const redirect = useRouteRedirect();

    const baseUrl = APP_ROUTES_TO_URL[APP_ROUTES_KEYS.addresses];

    const urls = useMemo<IRouteFn>(() => {
        const {list: LIST, item: ITEM} = PAGE;

        return {
            [ITEM]: (query?: IQuery) => (query ? `${baseUrl}/${query.id}` : baseUrl),
            [LIST]: () => baseUrl,
        };
    }, [baseUrl]);

    return useMemo<TRouteData<TAdressesPage>>(
        () => urlToRouteConverter({redirect, section: APP_ROUTES[APP_ROUTES_KEYS.addresses], urls}),
        [urls, redirect],
    );
};
